import "./EPCOServices.module.css";
import Header from "@/reusable_sections/Header";
import TheFullLifecycleModel from "./sections/TheFullLifecycleModel";
import OurCoreCapabilities from "./sections/OurCoreCapabilities";
import RequestATechnicalBrief from "./sections/RequestATechnicalBrief";
import SecurityIntelligenceFooter from "@/reusable_sections/Footer";
export default function EPCOServicesPage() {
  return <div>
      <Header />
      <TheFullLifecycleModel />
      <OurCoreCapabilities />
      <RequestATechnicalBrief />
      <SecurityIntelligenceFooter />
    </div>;
}